import Joi from 'joi';

export const contentBackgroundImageSchema = Joi.object({
  backgroundImage: Joi.optional(),
}).options({ stripUnknown: true });
